import React from 'react';
import banner from '../../images/photos/photo.jpg';
import ESNstar from '../../images/esn_logo.png'
const Pepehousing = () => {
    return ( 
        <div className="article-wrapper">
            <div className="image-wrapper container-fluid">
                <img src={banner} alt=""/>
            </div>
            <div className="content">
                <h3 className="star-header"><img src={ESNstar} alt=""/>Workgroups</h3>
                <div className="description">
                    Under construction
                </div>
            </div>
        </div>
     );
}
 
export default Pepehousing;